import IndigoServiceClient from 'communication/IndigoServiceClient';
import { ApiRequestOptions } from 'communication/ApiCallInfo';
import IndigoApiError from 'communication/IndigoApiError';
import { CorporateActionsRequest } from 'widgets/corpActions/api/CorporateActionsRequest';
import { CorporateActionsResponse } from 'widgets/corpActions/api/CorporateActionsResponse';

export async function corporateActionsSearch(
    indigoServiceClient: IndigoServiceClient,
    request: CorporateActionsRequest,
    options: ApiRequestOptions
): Promise<CorporateActionsResponse> {
    const {
        symbols,
        symbology,
        dateSearchType,
        corpActTypes,
        lookbackPeriod,
        lookforwardPeriod,
        limit,
    } = request;

    const formData = new FormData();
    formData.append('symbols', symbols);
    formData.append('symbology', symbology);
    formData.append('dateSearchType', dateSearchType);
    if (limit !== undefined) {
        formData.append('limit', limit.toString());
    }

    if (corpActTypes) {
        formData.append('corpActTypes', corpActTypes);
    }
    if (lookbackPeriod) {
        formData.append('lookbackPeriod', lookbackPeriod);
    }
    if (lookforwardPeriod) {
        formData.append('lookforwardPeriod', lookforwardPeriod);
    }

    const url = 'corpact/search';

    return await IndigoApiError.runHandlingErrorsAsync(
        `Corporate Actions Search`,
        async () => {
            return await indigoServiceClient.postFormData<CorporateActionsResponse>(
                url,
                formData,
                options
            );
        }
    );
}
